import React from 'react'
import View from './view'

const ContactHelpModal = ({ ...props }) => {
    return <View {...props} />
}

export default ContactHelpModal